"use client";

import clsx from "clsx";

import useCart from "@/lib/hooks/useCart";

import CartNotification from "@/components/molecules/CartNotification/CartNotification";
import missingYarnsCount from "@/lib/centra/utils/missingYarnsCount";
import {
  convertCartToGTagItem,
  eventViewCart
} from "@/lib/utils/Analytics/Functions";
import { useEffect } from "react";
import CartItems from "../CartItems/CartItems";
import CartSummary from "../CartSummary/CartSummary";
import styles from "./cart.module.css";
const CartContent = () => {
  const { items, modal, cart } = useCart();
  const missingRecipes = missingYarnsCount(cart);

  useEffect(() => {
    if (eventViewCart && modal.isOpen)
      eventViewCart({
        currency: cart.currency || "",
        items: items
          .map((item) => item.items.map((i) => convertCartToGTagItem(i)))
          .flat(),
        value: cart.summary?.prices.totalAsNumber
      });
  }, [modal.isOpen, items, cart.currency, cart.summary?.prices?.totalAsNumber]);

  return (
    <div className={clsx(styles["cart-content"])}>
      <CartItems items={items} />
      {cart?.summary?.totalQuantity && cart?.summary?.totalQuantity > 0 && (
        <CartSummary
          summary={cart.summary}
          missingYarns={missingRecipes.isMissing}
          modal={modal}
          labels={
            <CartNotification
              type="error"
              message={`${missingRecipes.text}`}
              show={missingRecipes.isMissing}
            />
          }
        />
      )}
    </div>
  );
};

export default CartContent;
